import styled from 'styled-components';

const StyledCardBanner = styled.div `
  ${props => props.flex &&
    `
      background-color: ${(props) => props.theme.colors.background.primary};
      display: flex;
      align-items: center;
      justify-content: space-between;

      > img {
        width: calc(50% - 10px);
      }

      > div {
        margin: 25px;
      }
    `}

  overflow: hidden;
  width: 100%;

  + * {
    padding-top: 32px;
  }

  > img {
    vertical-align: bottom;
  }
`;

export { StyledCardBanner };
